import { useMutation, UseMutationResult } from 'react-query';
import { api } from '../api';
import { AxiosError } from 'axios';
import { Entity } from '../types/entity';
import { PostResponseBody } from '../types/api-response';
import queryClient from '../query-client';

export type CreateXeroEntitiesRequest = {
    xeroUserId: string;
    xeroEntities: { tenantId: string; connectionId: string; group?: string }[];
};

async function createXeroEntities(req: CreateXeroEntitiesRequest): Promise<PostResponseBody<Entity>> {
    const { data } = await api.post('/entities/xero', req);
    return data;
}

export function useCreateXeroEntities(
    { invalidate } = { invalidate: true }
): UseMutationResult<PostResponseBody<Entity>, AxiosError, CreateXeroEntitiesRequest, unknown> {
    return useMutation(createXeroEntities, {
        onSettled: () => {
            if (invalidate) {
                queryClient.invalidateQueries(['entities']);
                queryClient.invalidateQueries(['firm']);
            }
        },
    });
}
